<template>
  <div>
    <b-row>
      <BaseInput
        id="folio_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.folio')"
        :value="folioFilter"
        @input="(val) => $emit('update:folioFilter', val)"
      />
      <BaseInput
        id="report_number_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.report_number')"
        :value="reportNumberFilter"
        @input="(val) => $emit('update:reportNumberFilter', val)"
      />
      <BaseInput
        id="sirh_filter"
        :cols="6"
        label="Sirh"
        :value="sirhFilter"
        @input="(val) => $emit('update:sirhFilter', val)"
      />
      <BaseInput
        id="rems_filter"
        :cols="6"
        label="Rems"
        :value="remsFilter"
        @input="(val) => $emit('update:remsFilter', val)"
      />
      <BaseSelect
        id="units_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.unit')"
        :value="unitsFilter"
        @input="(val) => $emit('update:unitsFilter', val)"
        :options="unitSelectOptions"
        :reduce="(item) => item.value"
        multiple
      />
      <BaseSelect
        id="activities_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.activities')"
        :value="activitiesFilter"
        @input="(val) => $emit('update:activitiesFilter', val)"
        :options="activityOptions"
        :reduce="(item) => item.value"
        multiple
      />
      <BaseSelect
        id="type_of_maintenance_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.type_of_maintenance')"
        :value="typeOfMaintenanceFilter"
        @input="(val) => $emit('update:typeOfMaintenanceFilter', val)"
        :options="typeOfMaintenanceOptions"
      />
      <BaseSelect
        id="is_test_mode_enabled_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.is_test_mode_enabled')"
        :value="isTestModeEnabledFilter"
        @input="(val) => $emit('update:isTestModeEnabledFilter', val)"
        :options="testModeEnabledOptions"
        :reduce="(item) => item.value"
      />
      <BaseSelect
        id="status_filter"
        :cols="6"
        :label="$t('operational_security.operational_processes.status')"
        :value="statusFilter"
        @input="(val) => $emit('update:statusFilter', val)"
        :options="statusOptions"
        :reduce="(item) => item.value"
      />
      <BaseDateTime
        id="created_at_filter"
        :cols="6"
        :label="$t('date.created_at')"
        :value="createdAtFilter"
        @input="(val) => $emit('update:createdAtFilter', val)"
        mode="range"
        :enable-time="false"
        date-format="Y-m-d"
      />
    </b-row>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BaseInput, BaseSelect, BaseDateTime } from "@/components/Form";

export default {
  name: "Filters",
  components: {
    BaseInput,
    BaseSelect,
    BaseDateTime,
  },
  props: {
    folioFilter: {
      type: String,
      default: null,
    },
    reportNumberFilter: {
      type: String,
      default: null,
    },
    sirhFilter: {
      type: String,
      default: null,
    },
    remsFilter: {
      type: String,
      default: null,
    },
    typeOfMaintenanceFilter: {
      type: String,
      default: null,
    },
    isTestModeEnabledFilter: {
      type: Boolean,
      default: null,
    },
    activitiesFilter: {
      type: Array,
      default: () => [],
    },
    unitsFilter: {
      type: Array,
      default: () => [],
    },
    statusFilter: {
      type: String,
      default: null,
    },
    createdAtFilter: {
      type: String,
      default: null,
    },
    unitOptions: {
      type: Array,
      default: () => [],
    },
    activityOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const typeOfMaintenanceOptions = ["Total", "Parcial"];

    const testModeEnabledOptions = [
      { value: true, label: "Sí" },
      { value: false, label: "No" },
    ];

    const statusOptions = [
      { value: "in_progress", label: "Sitio" },
      { value: "partial", label: "Parcial" },
      { value: "finished", label: "Salida" },
    ];

    const unitSelectOptions = computed(() => {
      return props.unitOptions?.map((unit) => ({
        value: unit.id,
        label: unit.description,
      }));
    });

    return {
      statusOptions,
      unitSelectOptions,
      testModeEnabledOptions,
      typeOfMaintenanceOptions,
    };
  },
};
</script>

